import GearView from './GearView'

export default GearView
